<template>
  <div>
    <!-- 高级搜索 -->
    <MTop title="检索" />
    <div class="s-box">
      <ul class="mobile-s-t">
        <li
          :class="index == id ?'isActive':''"
          @click="checkType($event)"
          v-for="(item,index) in titleArray"
          :id="index"
          :key="item.id"
        >{{item.name}}</li>
      </ul>
      <div>
        <el-row class="ser-row">
          <!-- 门类检索 -->
          <!-- <div class="weui-cell">
            <div class="weui-cell__hd">
              <label for class="weui-label width-40">
                <span style="color: #ff0000;">*</span>房屋类型
              </label>
            </div>
            <div class="weui-cell__bd">
              <input
                class="weui-input"
                type="text"
                id="house_type"
                name="house_type"
                value
                required
                readonly
              />
            </div>
          </div>-->
          <div class="ser-type clearfloat">
            <div class="fl f18">门类检索</div>
            <div class="fl f16 word-num" style="margin-left:10px;">{{$store.state.checkList}}</div>
            <div class="f18 txt-color1 fr" @click="checkCategory">
              <span style="margin-right:20px;" class>请选择</span>&gt;
            </div>
          </div>
          <!-- 分类检索 -->
          <div class="ser-type clearfloat" style="border-bottom:none;">
            <div class="fl f18">分类检索</div>
            <div class="fl f16 word-num" style="margin-left:10px;">{{$store.state.checkedOneList}}</div>

            <div class="f18 txt-color1 fr" @click="checkClassType">
              <span style="margin-right:20px;" class>请选择</span>&gt;
            </div>
          </div>
        </el-row>
        <el-row class="ser-row">
          <div class="ser-flex ser-type">
            <div class="f18">活动检索</div>
            <el-input
              @change="inputActiveName"
              style="flex:1;margin-left:20px;"
              v-model="activeName"
              class
              placeholder="输入活动名称"
            ></el-input>
          </div>
          <div class="ser-type clearfloat">
            <div class="fl f18">人物检索</div>
            <div
              class="fl f16 word-num"
              style="margin-left:10px;"
            >{{$store.state.checkedPersonList}}</div>

            <div @click="checkPerson" id="trigger1" class="f18 txt-color1 fr" style>
              <span style="margin-right:20px;" class>请选择</span>&gt;
            </div>
          </div>
          <div class="ser-type clearfloat">
            <div class="fl f18">地点检索</div>
            <div id="trigger2" class="f18 txt-color1 fr">
              <span style="margin-right:20px;" class>请选择</span>&gt;
            </div>
          </div>
          <!-- <div style="margin-top:20px;" class="tar">
            <el-button @click="checkInput" size="mini">切换</el-button>
          </div>-->
          <!-- <div class="ser-type clearfloat" style="border-bottom:none;">
            <div class="fl f18">机构检索</div>
         
            <div id="orgser" class="f18 txt-color1 fr">
              <span style="margin-right:20px;" class>请选择</span>&gt;
            </div>
          </div>-->
          <div class="ser-flex ser-type">
            <div class="f18">机构检索</div>
            <div class="f18 txt-color1">
              <el-input
                @change="selectOrg"
                placeholder="请输入机构名称"
                style="flex:1;margin-left:20px;"
                v-model="orgInput"
              ></el-input>
            </div>
          </div>
        </el-row>

        <el-row class="ser-row">
          <!-- 开始时间 -->
          <div class="ser-type clearfloat">
            <div class="fl f18">开始时间</div>
            <div class="fl f16 word-num" style="margin-left:10px;">{{startTime}}</div>

            <div class="f18 txt-color1 fr">
              <calendar :show.sync="calendarShow" @change="onBirthDayChange" />

              <span @click="checkStartTime" style="margin-right:20px;" class>请选择</span>&gt;
            </div>
          </div>
          <!-- 结束时间 -->
          <div class="ser-type clearfloat" style="border-bottom:none;">
            <div class="fl f18">结束时间</div>
            <div class="fl f16 word-num" style="margin-left:10px;">{{endTime}}</div>
            <calendar :show.sync="endShow" @change="onEndTimeChange" />
            <div class="f18 txt-color1 fr">
              <span @click="checkEndTime" style="margin-right:20px;" class>请选择</span>&gt;
            </div>
          </div>
        </el-row>
        <el-row class="ser-row">
          <div class="ser-flex ser-type" style="border-bottom:none;">
            <div class="f18">综合检索</div>
            <el-input
              @change="inputRet"
              v-model="retrieval"
              style="flex:1;margin-left:20px;"
              class
              placeholder="输入名称/标签/简介"
            ></el-input>
          </div>
        </el-row>
      </div>
      <!-- 按钮 -->
      <div style="margin:20px;">
        <el-button
          @click="submitSearch"
          style="width:100%;background:#00aaff;color:#fff;font-size:20px;"
        >检索</el-button>
      </div>
      <!-- <inlineCalendar /> -->
    </div>
  </div>
</template>

<script>
import map from "../../../static/json/district.json";
import { mapState } from "vuex";
//实现方法
function dateToMs(date) {
  let result = new Date(date).getTime();
  return result;
}
export default {
  data: function() {
    return {
      type: "",
      titleArray: [
        { id: 0, name: "全部" },
        { id: 1, name: "成片数据" },
        { id: 2, name: "素材数据" }
      ],
      id: 0,
      activeName: "", //活动检索
      location: "", //地点检索
      organizationLike: "", //机构检索
      startTime: "", //开始时间
      endTime: "", // 结束时间
      retrieval: "", // 综合检索
      // datePickerConfig: {
      //   yearsBefore: 15,
      //   yearsAfter: 0,
      //   initType: "ymd",
      //   initDate: "2019-01-01"
      // }
      calendarShow: false, //时间弹出框
      endShow: false,
      page: 1,
      limit: 10,
      videoTypeId: "", // 0表示素材，1表示成片 空为全部
      // showMode: this.$store.state.showMode //显示的模式 0 单视频 1视频集
      ifInput: false,
      orgInput: ""
    };
  },
  computed: mapState({
    organizationList: "organizationList",
    checkList: "checkList", //
    checkedPersonList: "checkedPersonList",
    videoOneValue: "videoOneValue",
    showMode: "showMode"
  }),
  methods: {
    //
    // checkInput: function() {
    //   console.log(this.ifInput);
    //   this.ifInput = !this.ifInput;
    
    // },
    selectOrg: function() {
      this.organizationLike = this.orgInput;
      this.$store.state.organizationLike = this.orgInput;
    },
    //
    inputRet: function() {
      this.$store.state.retrieval = this.retrieval;
    },
    inputActiveName: function() {
      this.$store.state.activeName = this.activeName;
    },
    // 提交检索
    submitSearch: async function() {
      var res = await this.$http.get(
        `/v1/index/highSearch?page=${this.page}&limit=${
          this.limit
        }&videoTypeId=${this.videoTypeId}&videoCreateBeginTime=${this
          .startTime || ""}&videoCreateEndTime=${this.endTime ||
          ""}&videoCategory=${this.checkList}&personNameLike=${
          this.checkedPersonList
        }&organizationLike=${this.organizationLike}&status=${
          this.showMode
        }&retrieval=${this.retrieval}&address=${this.location}&contentType=${
          this.videoOneValue
        }&activityTitle=${this.activeName}`
      );
      var { code, data, message } = res.data;
      if (code == 0) {
        console.log("list:", data);
        this.$store.state.videoList = data.recordList;
        this.$store.state.highSearchData = data;
        this.$store.state.page = 1;
        if (this.$route.query.value) {
          this.$router.push({
            path: "/mobvideolist",
            query: {
              value: this.$route.query.value
            }
          });
        } else {
          this.$router.push("/mobvideolist");
        }
      } else {
        this.$message.error(message);
      }
    },
    // 选择开始时间
    onBirthDayChange(date) {
      this.startTime = date.format("YYYY-MM-DD");
      this.$store.state.startTime = date.format("YYYY-MM-DD");
      // this.calendarShow = false
      console.log(dateToMs(this.startTime));
      if (this.endTime !== "") {
        if (dateToMs(this.startTime) - dateToMs(this.endTime) > 0) {
          this.startTime = "";
          this.$message.error("请选择结束时间以前的日期");
        }
      }
    },
    checkStartTime: function() {
      console.log(11);
      this.calendarShow = true;
    },
    onEndTimeChange: function(date) {
      this.endTime = date.format("YYYY-MM-DD");
      this.$store.state.endTime = date.format("YYYY-MM-DD");
      console.log(dateToMs(this.endTime));
      if (this.startTime !== "") {
        console.log(dateToMs(this.startTime) - dateToMs(this.endTime));
        if (dateToMs(this.startTime) - dateToMs(this.endTime) > 0) {
          this.endTime = "";
          this.$message.error("请选择开始时间以后的日期");
        }
      }

      // this.calendarShow = false;
    },
    checkEndTime: function() {
      this.endShow = true;
    },
    //
    checkType: function(e) {
      console.log(e);
      this.id = e.target.id;
      if (this.id == 0) {
        // 全部
        this.videoTypeId = "";
        this.$store.commit("changeTypeId", "");
      } else if (this.id == 1) {
        // 成片
        this.videoTypeId = 1;
        this.$store.commit("changeTypeId", 1);
      } else {
        // 素材
        this.videoTypeId = 0;
        this.$store.commit("changeTypeId", 0);
      }
    },
    // 下拉框
    init: function() {
      // 示例；
      //   var houseTypeObj = new MobileSelect({
      //     trigger: "#house_type",
      //     title: "请选择房屋类型",
      //     wheels: [{ data: ["小区房", "自建房", "商品房"] }],
      //     position: [0],
      //     callback: function(indexArr, data) {
      //       $("#house_type").val(data[0]);
      //       $("#house_type").blur();
      //     }
      //   });
      // 人物检索
      // var activeTypeObj = new MobileSelect({
      //   trigger:"#trigger1",
      //   title: '请选择人物',
      //   wheels:[{data:['1','2','3']}],
      //   position:[0],
      //   callback:function(indexArr,data){
      //     $('#trigger1').val(data[0]);
      //     $('#trigger1').blur();
      //   }
      // })
      // 地点
      var that = this;
      var optionArr = map;
      var locationObj = new MobileSelect({
        trigger: "#trigger2",
        title: "请选择地点",
        keyMap: {
          id: "id",
          value: "label",
          childs: "children"
        },
        wheels: [{ data: optionArr }],
        position: [0, 0],
        transitionEnd: function(indexArr, data) {
          // console.log(data)
        },
        callback: function(indexArr, data) {
          console.log(data);
          var arr = [];
          data.forEach(item => {
            arr.push(item.label);
          });
          that.location = arr.join(",");
          console.log(that.$store);
          that.$store.state.address = arr.join(",");
          console.log(that.location);
        }
      });
    },
    // 机构选择
    orgInit: function() {
      // 机构检索
      // this.getOrganizationList();
      var that = this;
      console.log(this.organizationList);
      var orgarr = this.organizationList;

      var orgObj = new MobileSelect({
        trigger: "#orgser",
        title: "请选择机构",
        keyMap: {
          id: "id",
          value: "title",
          childs: "children"
        },
        wheels: [{ data: orgarr }],
        position: [0, 0],
        transitionEnd: function(indexArr, data) {
          // console.log(data)
        },
        callback: function(indexArr, data) {
          // console.log(data);
          var arr = [];
          data.forEach(item => {
            arr.push(item.title);
          });
          that.organizationLike = arr.join(",");
          that.$store.state.organizationLike = arr.join(",");
          console.log(that.organizationLike);
        }
      });
    },
    // 门类检索
    checkCategory: function() {
      this.$router.push("/category1");
    },
    // 分类检索
    checkClassType: function() {
      this.$router.push("/category2");
    },
    // 人物检索
    checkPerson: function() {
      this.$router.push("/category3");
    }
    // 机构列表
    // getOrganizationList: async function() {
    //   var res = await this.$http.get(`/v1/index/organizationList`);
    //   var { code, data, message } = res.data;
    //   if (code == 0) {
    //     this.organizationList = data;
    //     console.log(data)
    //   }
    // },
  },
  mounted: function() {
    document.querySelector("#app").scrollIntoView(true);
    this.$store.dispatch("getOrgList");
    this.init();
    // this.orgInit();
    // this.$store.state.checkList = ''
    // this.getOrganizationList();
    if (this.$route.query.value) {
      this.retrieval = this.$route.query.value;
      this.submitSearch();
    }
  },
  watch: {
    "$store.state.showMode": function() {
      console.log(this.showMode);
      this.submitSearch();
    }
  }
};
</script>

<style lang="scss" scoped>
.s-box {
}
.word-num {
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.mobile-s-t {
  width: 100%;
  // padding:0 20px ;
  background-color: #fff;
  // border-bottom: 1px solid #ccc;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
}
.mobile-s-t li {
  float: left;
  padding: 10px;
  font-size: 16px;
  // height: 100%;
  // padding: 20px ;
}
.isActive {
  border-bottom: 2px solid #00aaff;
  color: #00aaff;
}
// 门类检索 分类检索
.ser-row {
  margin-top: 20px;
  background-color: #fff;
  padding: 0px 20px;
  .ser-type {
    padding: 20px 0px;
    border-bottom: 1px solid #dddddd;
  }
}
.ser-flex {
  display: flex;
  flex-direction: row;
  // justify-content: space-around;
  // vertical-align: middle;
  align-items: center;
}
</style>


// WEBPACK FOOTER //
// src/components/mobile/search.vue